import ContactsProvider from './Contacts.provider';

export default ContactsProvider;
